import React from 'react';
import UsersForm from './UsersForm';

const NewUserPage = () => <UsersForm formType="create" />;

export default NewUserPage;
